export const NEW_WORKSPACE_PATH = "/workspaces/new";

export const POWER_USER_EXTENSION_URL =
  "https://marketplace.visualstudio.com/items?itemName=innoverio.vscode-dbt-power-user";

export const WORKSPACES_DOCS_URL = "https://help.altimate.ai/workspaces/";

export const ALTIMATE_CODE_DOCS_URL = "https://docs.altimate.sh";

// The official Claude Code plugin for Altimate Code, from Anthropic's plugin
// directory. No marketplace suffix: current Claude Code names that marketplace
// `anthropic-plugin-directory`, so `@claude-plugins-official` fails to install.
export const CLAUDE_PLUGIN_COMMAND = "claude plugin install altimate-code";

export const CLAUDE_PLUGIN_URL = "https://claude.com/marketplace/plugins/altimate-code";

export const CLI_INSTALL_COMMAND = "npm install -g altimate-code";

// The first CLI release that links a project without the pilot flag: older
// releases have no `link` command, or refuse it unless ALTIMATE_WORKSPACE=1.
export const MIN_CLI_VERSION = "0.12.5";

export const CLI_VERSION_COMMAND = "altimate-code --version";

// Lists every altimate-code on PATH, for when an upgrade does not change the
// version because an older copy runs first.
export const CLI_PATH_COMMAND = "which -a altimate-code";

export const SLIDE_DURATION_MS = 9000;

export interface BenefitSlide {
  id: "context" | "sharing" | "projects";
  label: string;
}

export const BENEFIT_SLIDES: BenefitSlide[] = [
  { id: "context", label: "Build context" },
  { id: "sharing", label: "Share with your team" },
  { id: "projects", label: "Switch per project" },
];
